import '../styles/style.css'
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
function Gpa() {
    const [gqp, setgqp] = useState(0)
    const [ch, setCredithour] = useState(0)
    const [marks, setMarks] = useState("")
 
    var qp=gqp/ch;
    qp = Math.round(qp * 10) / 10;
   
    console.log(qp)
    useEffect(() => {
      if (gqp < 0) {
            setMarks("Invalid input: Quality Points cannot be negative"); 
        }
      else if (gqp > 12) {
            setMarks("Quality points Must be between 1-12"); 
            return
        }
       

        // Validate ch to avoid division by zero
        if (qp == 0) {
            setMarks("Enter Qp & Credit Hour First")
        }
        else if (qp <0) { setMarks("Quality Points Can not be in negative") }

        else if (qp == 4) {
            setMarks("Marks are 85 or More than 85");
        } else if (qp == 3.9) {
            setMarks("Marks are 83 or 84");
        } else if (qp == 3.8) {
            setMarks("Marks are 82");
        } else if (qp == 3.7) {
            setMarks("Marks are 80 or 81");
        } else if (qp == 3.6) {
            setMarks("Marks are 79");
        } else if (qp == 3.5) {
            setMarks("Marks are 77 or 78");
        } else if (qp == 3.4) {
            setMarks("Marks are 76");
        } else if (qp == 3.3) {
            setMarks("Marks are 74 or 75");
        } else if (qp == 3.2) {
            setMarks("Marks are 73");
        } else if (qp == 3.1) {
            setMarks("Marks are 71 or 72");
        } else if (qp == 3.0) {
            setMarks("Marks are 70");
        } else if (qp == 2.9) {
            setMarks("Marks are 69");
        } else if (qp == 2.8) {
            setMarks("Marks are 68");
        } else if (qp == 2.7) {
            setMarks("Marks are 67");
        } else if (qp == 2.6) {
            setMarks("Marks are 66");
        } else if (qp == 2.5) {
            setMarks("Marks are 65");
        } else if (qp == 2.4) {
            setMarks("Marks are 64");
        } else if (qp == 2.3) {
            setMarks("Marks are 63");
        } else if (qp == 2.2) {
            setMarks("Marks are 62");
        } else if (qp == 2.1) {
            setMarks("Marks are 61");
        } else if (qp == 2.0) {
            setMarks("Marks are 60");
        } else if (qp == 1.9) {
            setMarks("Marks are 59");
        } else if (qp == 1.8) {
            setMarks("Marks are 58");
        } else if (qp == 1.7) {
            setMarks("Marks are 57");
        } else if (qp == 1.6) {
            setMarks("Marks are 56");
        } else if (qp == 1.5) {
            setMarks("Marks are 55");
        } else if (qp == 1.4) {
            setMarks("Marks are 54");
        } else if (qp == 1.3) {
            setMarks("Marks are 53");
        } else if (qp == 1.2) {
            setMarks("Marks are 52");
        } else if (qp == 1.1) {
            setMarks("Marks are 51");
        }
        else if (qp == 1) {
            setMarks("Marks are 50");
        }
        else if (qp < 1.0) {
            setMarks("Less than 50, Re-appear");
        }
        else {
            setMarks("");
        }

    }, [qp,gqp]);

    return (
        <>
 <motion.div
      className="container-fluid mt-5 p-4"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="row align-items-center text-center text-md-start">
        <div className="col-md-6">
          <motion.h1
            className="fw-bold text-primary"
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1 }}
          >
            QP to Marks Calculator
          </motion.h1>
          <motion.p
            className="fw-semibold text-muted"
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            This calculator helps you convert QP to marks easily.
            Your My-IUB portal may show you just the Quality points of yours in some subject,
            Marks are usually not displayed there. With the help of this portal you can get an idea about your marks 
            based on obtained Quality points.
           
          </motion.p>
        </div>
        <div className="col-md-6 d-flex justify-content-center justify-content-md-end">
          <motion.img
            src="/images/dcs.png"
            alt="dcs"
            className="img-fluid mx-2"
            height={50}
            width={100}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.8 }}
          />
          <motion.img
            src="/images/iub.png"
            alt="iub"
            className="img-fluid mx-2"
            height={50}
            width={100}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          />
        </div>
      </div>

      <motion.div
        className="mt-5 row justify-content-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        <div className="col-md-5">
          <label className="fw-bold">Enter Your QP:</label>
          <input
            type="number"
            className="form-control mt-2 shadow-sm"
            placeholder="Enter QP..."
            onChange={(e) => setgqp(Number(e.target.value))}
          />
        </div>
        <div className="col-md-5 mt-3 mt-md-0">
          <label className="fw-bold">Enter Credit Hour Of Subject:</label>
          <input
            type="number"
            className="form-control mt-2 shadow-sm"
            placeholder="Enter Credit Hour..."
            onChange={(e) => setCredithour(Number(e.target.value))}
          />
        </div>
      </motion.div>

      <motion.div
        className="mt-4 text-center"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.8, delay: 1 }}
      >
        <h3 className="fw-bold text-primary mb-5">Your Marks:<br></br> {marks}</h3>
        <br></br>
 
      </motion.div>
    </motion.div>
        </>
    )
};
export default Gpa;